import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import Store from '../../../Store/Store';
import { WOS_BASIC_02_Schema } from './M_WOS_BASIC_02_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

/** 작업중지 상세 조회 GetWosBasicR2 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_02_Schema.mapper.search1,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasicR2,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 작업재개 승인/수정 저장 SaveWosBasicU2 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo =
      vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      WOS_BASIC_02_Schema.mapper.save1,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.WorkStop.saveWosBasicU2,
      payload
    );
  }, options);
};
